import { Caption, Tappable } from '@vkontakte/vkui';
import { classNames } from '@vkontakte/vkjs';
import { Icon24RefreshOutline } from '@vkontakte/icons';
import { QrCodeFallbackErrorProps } from './types';
import { defaultQrSize } from './consts';
import styles from './QrCodeBase.module.css';

/**
 * Компонент retry для qrCode
 * @param errorText - сообщение об ошибке
 * @param retry - функция попытки обновления qrCode
 * @param size - размер qrCode
 */
export function QrCodeFallbackError(props: QrCodeFallbackErrorProps) {
  const { errorText, retry, size = defaultQrSize, className } = props;

  return (
    <Tappable
      className={classNames(styles.root, styles.root__isLoading, styles.root__isRetry, className)}
      style={{ width: size, height: size }}
      onClick={retry}
      hoverMode="opacity"
      activeMode="opacity"
    >
      <div className={styles.retry}>
        <Icon24RefreshOutline className={styles.retryIcon} />
        <Caption weight="3" level="1" useAccentWeight>
          {errorText}
        </Caption>
      </div>
    </Tappable>
  );
}
